import React, { useState } from "react";
import { Card, Input, Button, message, Typography, Divider, Spin } from "antd";
import {
  useGetMyTotalBalanceQuery,
  useWithdrawMoneyMutation,
} from "../slices/paymentApiSlice";

const { Title, Text } = Typography;

const WithdrawScreen = () => {
  const [amount, setAmount] = useState("");

  const { data, isLoading } = useGetMyTotalBalanceQuery();
  const [withdrawMoney, { isLoading: withdrawLoading }] =
    useWithdrawMoneyMutation();

  const totalBalance = data?.balance || 0;

  const withdrawHandler = async () => {
    if (!amount || Number(amount) <= 0) {
      return message.error("Enter valid amount");
    }

    if (Number(amount) > totalBalance) {
      return message.error("Insufficient balance");
    }

    try {
      await withdrawMoney({ amount: Number(amount) }).unwrap();

      message.success("Withdrawal successful");
      setAmount("");
    } catch (error) {
      message.error(error?.data?.message || "Withdrawal failed");
    }
  };

  return (
    <Card
      title="Wallet"
      style={{
        maxWidth: 500,
        margin: "40px auto",
        borderRadius: 12,
      }}
    >
      {/* Balance */}
      <div style={{ textAlign: "center", marginBottom: 25 }}>
        {isLoading ? (
          <Spin />
        ) : (
          <>
            <Text type="secondary">Available Balance</Text>
            <Title level={2} style={{ margin: 0, color: "#1677ff" }}>
              ₹ {totalBalance.toFixed(2)}
            </Title>
          </>
        )}
      </div>

      <Divider />

      {/* Withdraw */}
      <Title level={5}>Withdraw Money</Title>

      <Input
        type="number"
        placeholder="Enter Amount"
        value={amount}
        onChange={(e) => setAmount(e.target.value)}
        style={{ marginBottom: 20 }}
      />

      <Button
        type="primary"
        loading={withdrawLoading}
        onClick={withdrawHandler}
        block
          className="gold-btn"

      >
        Withdraw
      </Button>
    </Card>
  );
};

export default WithdrawScreen;